export default [{
  path: '/region',
  name: 'region',
  meta: {
    layout: 'main'
  },
  component: () => import('@/views/region/index')
}]
